import { Box, Divider, Typography } from "@mui/material";

export interface PageHeaderProps {
  title: string;
  icon?: React.ReactNode;
  rightContent?: React.ReactNode;
}

export const PageHeader = ({ title, icon, rightContent }: PageHeaderProps) => {
  return (
    <Box>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          gap: { sm: 2, xs: 1 },
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Box sx={{ alignItems: "center", display: "flex", gap: { sm: 2, xs: 1 }, minWidth: 0 }}>
          {icon ? <Box sx={{ alignItems: "center", display: "flex", flexShrink: 0, lineHeight: 0 }}>{icon}</Box> : null}
          <Typography component="h1" sx={{ minWidth: 0 }} variant="page-header">
            {title}
          </Typography>
        </Box>
        {rightContent}
      </Box>
      <Divider />
    </Box>
  );
};
